import { AuthProvider } from '../../context/AuthContext';

export const AuthLayout = ({ children }) => {
    return <AuthProvider>{children}</AuthProvider>;
};
